export default "__VITE_ASSET__f7ff16b6__"